import pathify from 'vuex-pathify'
import { CookieName } from '~/auth/constants'

export const state = () => ({})

export const strict = false
export const plugins = [pathify.plugin]

export const actions = {
  async nuxtServerInit({ commit, dispatch }, { req, $config, app }) {
    dispatch('subscription/initialize', $config)
    commit('language/SET_LOCALE', app.i18n.locale)

    const token = req.cookies?.[CookieName.ACCESS_TOKEN]
    if (!token) {
      commit('user/SET_USER', null)
      return
    }

    try {
      const url = `${req.headers['x-forwarded-proto'] || 'http'}://${req.headers.host}`

      // rebuild the header using req.cookies, which contains our fresh tokens. The raw req.headers.cookie string is
      // stale and still contains the expired tokens.
      const cookie = Object.entries(req.cookies)
        .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`)
        .join('; ')

      const response = await fetch(`${url}/api/auth/me`, {
        headers: {
          Cookie: cookie
        }
      })

      if (!response.ok) {
        const body = await response.json().catch(() => null)

        if (response.status === 401) {
          // token is genuinely invalid - clear the session so the user can re-authenticate
          console.error('nuxtServerInit: token rejected (401), clearing session cookies', body)
          commit('user/SET_USER', null)
          app.$cookies.remove(CookieName.ACCESS_TOKEN)
          app.$cookies.remove(CookieName.REFRESH_TOKEN)
        } else {
          // transient error (5xx, network issue, etc.) - keep cookies so recovery is possible on next visit
          console.error(
            `nuxtServerInit: /api/auth/me failed with status ${response.status}, keeping session cookies`,
            body
          )
          commit('user/SET_USER', null)
        }

        return
      }

      const user = await response.json()
      commit('user/SET_USER', user)
    } catch (error) {
      // network-level error (timeout, DNS, etc.) - keep cookies intact so the user is not permanently logged out
      console.error('nuxtServerInit: network error fetching user, keeping session cookies:', error.message)
      commit('user/SET_USER', null)
    }
  }
}
